import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ngcArrayStates'
})
export class ArrayStatesPipe implements PipeTransform {

    transform(states: any, countryIso: string): any {
        if (countryIso && states[countryIso] != undefined) {
            return states[countryIso];
        }
        return null ;
    }

}
